import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { PetEvolutionStage, PetSpeciesID } from 'src/replicant/pet';
import * as Pet from 'src/replicant/pet';
import uiConfig from 'src/lib/ui/config';
import bitmapFonts from 'src/lib/bitmapFonts';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import { getCreativeSuffix } from 'src/lib/utils';
import StateObserver from 'src/StateObserver';
import { getPetSpeciesBucket } from 'src/replicant/pet/pet.getters';

export class GrowthRecordTile extends View {
  constructor(
    opts: ViewOpts,
    tileOpts: {
      stage: PetEvolutionStage;
      species: PetSpeciesID;
      arrow: 'left' | 'right' | 'none';
    },
  ) {
    super({ width: uiConfig.popups.buruburu.width, height: 220, ...opts });

    const badge = new ImageScaleView({
      superview: this,
      width: 116,
      height: 113,
      image: `assets/ui/family/icons/${tileOpts.stage}_badge.png`,
      centerOnOrigin: true,
      y: this.style.height * 0.37,
      x: 200,
    });

    const frame = new ImageScaleView({
      superview: this,
      image: `assets/ui/family/frames/age_frame.png`,
      width: 226,
      height: 60,
      centerOnOrigin: true,
      x: badge.style.x,
      y: badge.style.y + 90,
    });

    new LangBitmapFontTextView({
      superview: frame,
      x: frame.style.width / 2,
      y: frame.style.height / 2,
      width: frame.style.width - 50,
      height: frame.style.height,
      align: 'center',
      verticalAlign: 'center',
      size: 25,
      color: '#BF8147',
      font: bitmapFonts('Body'),
      canHandleEvents: false,
      centerOnOrigin: true,
      localeText: () => i18n(`stage.${tileOpts.stage}`),
    });

    const polaroid = new ImageScaleView({
      superview: this,
      width: 168,
      height: 195,
      image: 'assets/ui/family/frames/polaroid.png',
      x: 450,
      y: this.style.height * 0.5,
      r: tileOpts.arrow === 'left' ? 0.1 : -0.1,
      centerOnOrigin: true,
    });
    const { user } = StateObserver.getState();
    const evolutions = Pet.ruleset.evolutions[getPetSpeciesBucket(user)];

    new LangBitmapFontTextView({
      superview: polaroid,
      x: polaroid.style.width / 2,
      y: 163,
      width: polaroid.style.width - 25,
      height: 30,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      color: '#BF8147',
      font: bitmapFonts('Body'),
      canHandleEvents: false,
      centerOnOrigin: true,
      localeText: () =>
        evolutions[tileOpts.species]?.[`name_${getCreativeSuffix()}`],
    });

    new ImageScaleView({
      superview: polaroid,
      width: 90,
      height: 90,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      image: `assets/ui/species/linepet_${tileOpts.species}.png`,
      x: polaroid.style.width * 0.5,
      y: polaroid.style.height * 0.44,
    });

    if (tileOpts.arrow === 'none') return;

    new ImageScaleView({
      superview: this,
      backgroundColor: '#FFF5E3',
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height,
      width: this.style.width - 10,
      height: 4,
    });

    const arrowStyle =
      tileOpts.arrow === 'left'
        ? { x: 355, y: 210 }
        : { x: 540, y: 205, flipX: true };

    new ImageScaleView({
      superview: this,
      image: 'assets/ui/family/icons/arrow.png',
      width: 33,
      height: 62,
      centerOnOrigin: true,
      ...arrowStyle,
    });
  }
}
